import { useLocation } from 'react-router-dom';
import { BugReportButton } from '@/components/BugReport';

export function Footer() {
  const location = useLocation();

  const hideFooterRoutes = ['/chatbot'];
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  if (shouldHideFooter) return null;

  return (
    <footer
      // eslint-disable-next-line max-len
      className='fixed bottom-0 left-0 w-full flex justify-end items-center z-50 bg-transparent pointer-events-none pr-8'
      style={{ minHeight: '60px' }}
    >
      <div className='pointer-events-auto mb-2 hover:animate-bounce duration-300'>
        <BugReportButton />
      </div>
    </footer>
  );
}
